import { useState, useEffect, lazy, Suspense } from "react";
import HeroSection from "./components/HeroSection";
import TrendingSection from "./components/TrendingSection";
import { homeContentService } from "./services/homeContent";
import styles from "./page.module.css";
import { auth } from "./firebase/config.js";
import SeoHead from "@/components/SeoHead";
import {
  defaultSiteDescription,
  defaultSiteTitle,
} from "@/lib/seoConfig";

const BestSellersSection = lazy(() => import("./components/BestSellersSection"));
const NewSection = lazy(() => import("./components/NewSection"));
const FeaturesSection = lazy(() => import("./components/FeaturesSection"));

function BestSellersFallback() {
  return <div className={styles.sectionFallback} aria-hidden />;
}

export default function Home() {
  const [homeContent, setHomeContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadHomeContent();
  }, []);

  const loadHomeContent = async () => {
    try {
      const content = await homeContentService.getAllSections();
      if (content && content.sections) {
        const homeSection = content.sections.find(
          (section) => section.name === "home"
        );
        if (homeSection) {
          setHomeContent(homeSection.sections);
        }
      }
    } catch (error) {
      console.error("Error loading home content:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <SeoHead
          title={defaultSiteTitle}
          description={defaultSiteDescription}
          canonicalPath="/"
        />
        <div className={styles.container}>
          <div className={styles.content}>
            <HeroSection content={null} />
            <TrendingSection content={null} />
            <Suspense fallback={<BestSellersFallback />}>
              <BestSellersSection />
            </Suspense>
            <Suspense fallback={<BestSellersFallback />}>
              <NewSection content={null} />
            </Suspense>
            {!auth.currentUser && (
              <Suspense fallback={<BestSellersFallback />}>
                <FeaturesSection content={null} />
              </Suspense>
            )}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <SeoHead
        title={defaultSiteTitle}
        description={defaultSiteDescription}
        canonicalPath="/"
      />
      <div className={styles.container}>
        <div className={styles.content}>
          <HeroSection
            content={homeContent?.find((section) => section.id === "hero")}
          />
          {!auth.currentUser && (
            <Suspense fallback={<BestSellersFallback />}>
              <FeaturesSection
                content={homeContent?.find(
                  (section) => section.id === "features"
                )}
              />
            </Suspense>
          )}
          <TrendingSection
            content={homeContent?.find((section) => section.id === "trending")}
          />
          <Suspense fallback={<BestSellersFallback />}>
            <BestSellersSection />
          </Suspense>
          <Suspense fallback={<BestSellersFallback />}>
            <NewSection
              content={homeContent?.find((section) => section.id === "new")}
            />
          </Suspense>
        </div>
      </div>
    </>
  );
}
